import React, { useState, useEffect } from 'react';

import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';
import AgentMarxSingle from './AgentMarxSingle';

export default function AgentMarxTotal({ props, item, flag, onClick }) {
  const flagLegend = {
    deceasedFlag: 'danger',
    currentPlanFlag: 'info',
    futurePlanFlag: 'warning',
    badMbiFlag: 'danger',
  };

  const [marxFlagTotalData, setMarxFlagTotalData] = useState(item);

  let classData = [
    'btn',
    'border',
    'mt-2',
    'mr-2',
    'mb-4',
    'border-' + flagLegend[marxFlagTotalData.flag],
  ];

  flag == marxFlagTotalData.flag ? classData.push('btn-' + flagLegend[marxFlagTotalData.flag]) : '';

  //const [flagViewing, setFlagViewing] = useState(flag);

  const handleFetchMarxDataByFlag = (flag) => {
    if (onClick) {
      onClick(flag);
    }
  };

  return (
    marxFlagTotalData.total > 0 && (
      <div
        onClick={() => handleFetchMarxDataByFlag(marxFlagTotalData.flag)}
        className={classData.join(' ')}
      >
        {marxFlagTotalData.label} ({marxFlagTotalData.total})
      </div>
    )
  );
}
